// extracted by mini-css-extract-plugin
module.exports = {"block":"d9bd5f2","container":"_3cd2373"};